;( function( $, undefined )
{
    $.fn.RecommendedContent = function()
    {
        $.ajax( {
            type     : 'POST',
            url      : arguments[ 2 ].url,
            data     : arguments[ 1 ],
            success  : function( data )
            {
                var threads  = [],
                    $content = $( '#recommended-content-comp' );

                $( data.content ).find( 'table tbody tr' ).each( function()
                {
                    var start = this.className.indexOf( 'lia-js-data-messageUid-' ) + 23,
                        end   = this.className.indexOf( ' lia-js-data-messageRevision-' ),
                        id    = this.className.slice( start, end );

                    threads.push( id );
                } );

                if( threads.length )
                {
                    $content.load( '/t5/custom/page/page-id/related-threads/ #related-threads', { th : "'" + threads.join( "','" ) + "'" }, function(){} );
                }
                else
                {
                    $content.html( '' );
                }
            }
        } );
    };

} )( jQuery );